import React from 'react'
import MetarDetailSection from './MetarDetailSection'
import MetarDetailSectionItem from './MetarDetailSectionItem'

const MetarDetailWind = props => {
  let windVariableDirection
  if(props.windVariableDirection && props.windVariableDirection.length > 0) {
    windVariableDirection = props.windVariableDirection.join(" - ")
  }
  return (
    <MetarDetailSection
      title={"WIND"}
    >
      <MetarDetailSectionItem
        header={windVariableDirection ?
          windVariableDirection :
          props.windGust ?
            '\xA0' :
            undefined}
        value={props.windDirection}
        footer={"BEARING"}
      />
      <MetarDetailSectionItem
        header={props.windGust || windVariableDirection ? '\xA0' : undefined}
        value={props.windSpeed}
        footer={"KTS"}
      />
      <MetarDetailSectionItem
        header={"GUSTS"}
        value={props.windGust}
        footer={"KTS"}
      />
    </MetarDetailSection>
  )
}

export default MetarDetailWind



// WEBPACK FOOTER //
// ./src/components/MetarDetailWind.js